import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { useUserWithRole } from 'hooks/custom-auth';

import LoadingFullPage from 'components/loading-full-page';
import ErrorBoundary from 'components/error-boundary';

const PrivateRoute = ({
  auth,
  component: Component,
  confirmedUser,
  routes,
  worker,
  admin,
  employer,
  ...rest
}) => {
  const [user, loading, error] = useUserWithRole(auth);

  if (loading) return <LoadingFullPage />;
  if (error) throw error;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!user)
          return (
            <Redirect
              to={{ pathname: '/login', state: { from: props.location } }}
            />
          );

        if (!user.emailVerified && confirmedUser) {
          return (
            <Redirect
              to={{
                pathname: '/confirmation-sent',
                state: { from: props.location },
              }}
            />
          );
        }

        const { role } = user.claims;

        if (admin === true && user.claims.admin === false) {
          return (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          );
        }

        if (
          (worker && role !== 'isWorker') ||
          (employer && role !== 'isEmployer')
        )
          return (
            <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          );

        return (
          <ErrorBoundary>
            <Component {...props} routes={routes} />
          </ErrorBoundary>
        );
      }}
    />
  );
};

PrivateRoute.propTypes = {
  auth: PropTypes.shape({
    currentUser: PropTypes.shape({}),
  }).isRequired,
  confirmedUser: PropTypes.bool,
  component: PropTypes.func.isRequired,
  location: PropTypes.shape(),
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  employer: PropTypes.bool,
  worker: PropTypes.bool,
  admin: PropTypes.bool,
};

PrivateRoute.defaultProps = {
  confirmedUser: false,
  location: undefined,
  routes: null,
  employer: false,
  worker: false,
  admin: false,
};

export default PrivateRoute;
